var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLightBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.97738 13.256H7.28208C7.57998 13.256 7.82196 13.498 7.82196 13.7959C7.82196 14.0941 7.57998 14.3357 7.28208 14.3357H2.97738C2.67915 14.3357 2.4375 14.0941 2.4375 13.7959C2.4375 13.498 2.67915 13.256 2.97738 13.256Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.97738 14.9203H7.28208C7.57998 14.9203 7.82196 15.1623 7.82196 15.4602C7.82196 15.7584 7.57998 16 7.28208 16H2.97738C2.67915 16 2.4375 15.7584 2.4375 15.4602C2.4375 15.1623 2.67915 14.9203 2.97738 14.9203Z",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.71548 12.2744V9.43985C7.71515 9.42687 7.71448 9.41389 7.71448 9.40058C7.71448 8.87335 7.94182 8.39904 8.30395 8.07119V8.06753C9.21628 7.21677 9.78778 6.00521 9.78778 4.65951C9.78778 2.08595 7.7015 0 5.12827 0C2.55503 0 0.46875 2.08595 0.46875 4.65951C0.46875 6.01087 1.04491 7.22742 1.9639 8.07851V8.08051C2.32004 8.4087 2.54338 8.87834 2.54338 9.40058C2.54338 9.43186 2.54272 9.46282 2.54105 9.49344V10.6245H6.28025C6.53854 10.6245 6.7479 10.8335 6.7479 11.0918C6.7479 11.3497 6.53854 11.5591 6.28025 11.5591H2.54105V12.2744C2.54105 12.4115 2.65189 12.5223 2.78869 12.5223H7.46784C7.60464 12.5223 7.71548 12.4115 7.71548 12.2744Z",
    fill: "#FF6600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightBulb);
export default __webpack_public_path__ + "static/media/icon-light-bulb.af081564d9472a2e8aecce6179aa1026.svg";
export { ForwardRef as ReactComponent };